import React, { useContext, ReactNode } from 'react';
import { Route } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import Overall from '../Performance/Overall';
import Streaming from '../Performance/Streaming';
import Download from '../Performance/Download';
import Physical from '../Overview/Physical';

import { performanceSubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import { EntityContext } from 'context/entityContext';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import Playlist from '../Performance/Playlist';

const Performance: React.FC<IEntityPageComponentProps> = (props) => {
  const { match, pathPrefix } = props;
  const { entityId, parentEntityId } = match.params;

  const { compareMode, topic } = useContext(EntityContext);

  return (
    <>
      <SubNavigation topic="performance" variants={performanceSubTopics} />
      <TopicFilters topic={topic[1] || topic[0]} compareMode={compareMode} />

      <Route
        exact
        path={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/performance/all`}
        render={(): ReactNode => <Overall />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/performance/streaming`}
        render={(): ReactNode => <Streaming />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/performance/download`}
        render={(): ReactNode => <Download />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/performance/physical`}
        render={(): ReactNode => <Physical />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/performance/playlist`}
        render={(): ReactNode => <Playlist />}
      />
    </>
  );
};

export default Performance;
